module.exports = __webpack_public_path__ + "img/482.7a2c7e5b.png";